import { axiosInstance } from "contexts/axiosApiInstance";
import { createLogger } from "debug/DebugingLogger";

const log = createLogger("AccountDeletionServices");

export interface AccountModelInfo {
  model_id: string;
  model_name: string;
  tables: AccountTableInfo[];
}

export interface AccountTableInfo {
  table_id: string;
  table_name: string;
  usage_status: "Critical" | "Moderate" | "Low";
}

export interface AccountDeletionAnalysis {
  models: AccountModelInfo[];
}

export const fetchAccountDeletionAnalysis =
  async (): Promise<AccountDeletionAnalysis> => {
    try {
      const response = await axiosInstance.get(
        "/action/account/deletion-analysis",
      );
      return response.data;
    } catch (error) {
      log.error("Failed to fetch account deletion analysis", error);
      throw error;
    }
  };
